import { useTranslation } from 'react-i18next';
import { BaseFieldProps, Field } from 'redux-form';

import { CountryCode } from 'lib/constants/locales';
import { isLength, isRequired, sanitize, withMessage } from 'lib/utils/formValidation';
import ThemedMaskedInput, { ThemedMaskedInputProps } from 'verify/components/ThemedMaskedInput';

const validate = {
  socialSecurityNumber: [
    withMessage('You cannot have an empty value', isRequired),
    // TODO(tony): Update validation per localization.
    withMessage('The value you entered is invalid', sanitize(/\D/g, isLength(9))),
  ],
};

interface SsnFullFieldProps {
  disabled?: boolean;
  name?: string;
  countryCode?: CountryCode;
}

export default function SsnFullField(props: SsnFullFieldProps) {
  const { disabled, name = 'social-security-number' } = props;

  return (
    <Field<ThemedMaskedInputProps & BaseFieldProps>
      name={name}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      label={LocalizedLabel(props.countryCode)}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      component={ThemedMaskedInput}
      disabled={disabled}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      mask={LocalizedMask(props.countryCode)}
      type='text'
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      placeholder={LocalizedHint(props.countryCode)}
      validate={validate.socialSecurityNumber}
    />
  );
}

function LocalizedLabel(countryCode: CountryCode) {
  const [t] = useTranslation();
  switch (countryCode) {
    case 'BR':
      return t('form.identification-number.country.BR');
    case 'CA':
      return t('form.identification-number.country.CA');
    case 'DE':
      return t('form.identification-number.country.DE');
    case 'FR':
      return t('form.identification-number.country.FR');
    case 'GB':
      return t('form.identification-number.country.GB');
    case 'IT':
      return t('form.identification-number.country.IT');
    case 'JP':
      return t('form.identification-number.country.JP');
    case 'KR':
      return t('form.identification-number.country.KR');
    case 'MX':
      return t('form.identification-number.country.MX');
    case 'NL':
      return t('form.identification-number.country.NL');
    case 'PL':
      return t('form.identification-number.country.PL');
    case 'RO':
      return t('form.identification-number.country.RO');
    case 'RU':
      return t('form.identification-number.country.RU');
    case 'US':
      return t('form.identification-number.country.US');
    default:
      return t('form.identification-number.identification-number');
  }
}

function LocalizedHint(countryCode: CountryCode) {
  switch (countryCode) {
    case 'BR':
      return '###.###.###-##';
    case 'CA':
      return '###-###-###';
    case 'DE':
      return '############';
    case 'FR':
      return '###############';
    case 'GB':
      return '###-###-####';
    case 'IT':
      return '################';
    case 'JP':
      return '############';
    case 'KR':
      return '######-#######';
    case 'MX':
      return '##################';
    case 'NL':
      return '#########';
    case 'PL':
      return '###########';
    case 'RO':
      return '#############';
    case 'RU':
      return '###-###-### ##';
    case 'US':
      return '###-##-####';
    default:
      return '###-##-####';
  }
}

function LocalizedMask(countryCode: CountryCode) {
  return Array.from(LocalizedHint(countryCode)).map((c) => (c === '#' ? /\d/ : c));
}
